<template>
  <pre
    class="so-code-block"
    :class="`language-${language}`"
    :data-testid="dataTestId"
  ><code v-html="highlighted"></code></pre>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { highlightCode, CodeLanguage } from "@/helpers/codeHighlightHelper"

  export default defineComponent({
    props: {
      code: {
        type: String,
        default: "",
      },
      language: {
        type: String as PropType<CodeLanguage>,
        default: "markup",
      },
      dataTestId: {
        type: String,
        default: undefined,
      },
    },
    computed: {
      highlighted(): string {
        return highlightCode(this.code, this.language)
      },
    },
  })
</script>

<style scoped>
  .so-code-block {
    margin: 0;
    padding: 16px;
    background: var(--code-background, rgb(var(--v-theme-surface)));
    border-radius: var(--theme-radius);
    font-family: monospace;
    font-size: 0.8125rem;
    line-height: 1.5;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    overflow: auto;
  }
</style>
